<template>
  <div class="tips">
    <transition name="transition--tips">
      <div
        :key="'TIP__' + view + tip"
        class="tips__tip"
        v-html="tips[view][tip]"
      />
    </transition>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  data () {
    return {
      interval: false,
      view: 'search',
      tip: 0,
      tips: {
        'search': [
          'Tip: <i>Begin with free search and use filters to pinpoint results.</i> <span>[1/5]</span>',
          'Tip: <i>Or start searching directly with filters to browse available data.</i> <span>[2/5]</span>',
          'Tip: <i>Combine multiple filters to narrow down search results.</i> <span>[3/5]</span>',
          'Tip: <i>You can add multiple filters of the same type too.</i> <span>[4/5]</span>',
          'Tip: <i>Add notifications to receive email whenever new data is published.</i> <span>[5/5]</span>',
        ],
        'datasets': [
          'Tip: <i>Begin with free search and use filters to pinpoint results.</i> <span>[1/5]</span>',
          'Tip: <i>Or start searching directly with filters to browse available data.</i> <span>[2/5]</span>',
          'Tip: <i>Combine multiple filters to narrow down search results.</i> <span>[3/5]</span>',
          'Tip: <i>You can add multiple filters of the same type too.</i> <span>[4/5]</span>',
          'Tip: <i>Add notifications to receive email whenever new data is published.</i> <span>[5/5]</span>',
        ],
        'pdfs': [
          'Tip: <i>Begin with free search and use filters to pinpoint results.</i> <span>[1/5]</span>',
          'Tip: <i>Or start searching directly with filters to browse available data.</i> <span>[2/5]</span>',
          'Tip: <i>Combine multiple filters to narrow down search results.</i> <span>[3/5]</span>',
          'Tip: <i>You can add multiple filters of the same type too.</i> <span>[4/5]</span>',
          'Tip: <i>Add notifications to receive email whenever new data is published.</i> <span>[5/5]</span>',
        ],
        'news': [
          'Tip: <i>Begin with free search and use filters to pinpoint results.</i> <span>[1/5]</span>',
          'Tip: <i>Or start searching directly with filters to browse available data.</i> <span>[2/5]</span>',
          'Tip: <i>Combine multiple filters to narrow down search results.</i> <span>[3/5]</span>',
          'Tip: <i>You can add multiple filters of the same type too.</i> <span>[4/5]</span>',
          'Tip: <i>Add notifications to receive email whenever new data is published.</i> <span>[5/5]</span>',
        ]
      }
    }
  },
  methods: {
    createInterval () {
      this.interval = setInterval(function () {
        this.tip++
        if (this.tip >= this.tips[this.view].length) {
          this.tip = 0
        }
      }.bind(this), 7500)
    },
    ...helperMethods
  },
  watch: {
    /* TEMPORARILY DISABLED - Enable again when we have separate tips per view
    $route (to, from) {
      if (from.name !== to.name) {
        this.view = this.getSearchView()
        this.tip = 0
        clearInterval(this.interval)
        this.createInterval()
      }
    }*/
  },
  created () {
    this.createInterval()
  },
  unmounted () {
    clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.tips {
  @include font('content--md', $white, 0.7);
  position: relative;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 39px;
  display: none;

  @media screen and (max-width: 639px) {
    display: flex;
  }

  @media screen and (min-width: 880px) {
    display: flex;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.7);
  }

  &__tip {
    position: absolute;
    left: 12px;
    right: auto;

    @media screen and (min-width: $breakpointSm) {
      left: auto;
      right: 4px;
    }

    /deep/ span {
      color: rgba($white, 0.4);
    }
  }
}

.transition--tips-leave-active, .transition--tips-enter-active {
  transition: opacity 0.8s ease-in;
}
.transition--tips-enter, .transition--tips-leave-to {
  opacity: 0;
}
.transition--tips-leave, .transition--tips-enter-to {
  opacity: 1;
}

</style>
